import URL_A from '@/http/configuration/app';
import URL_S from '@/http/configuration/societe';
export default {
  namespaced: true,
  state: {
    config: {
      appName: 'DX360',
      appDeveloper: 'D-XPERTS',
      appVersion: '1.0',
      defaultLangue: {
        code: 'en',
        icon: 'gb',
        nom: 'Anglais',
      },
      langues: [],
    },
    defaultCurrencyConfig: {
      symbol: '€',
      thousandsSeparator: ' ',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'back',
      symbolSpacing: true,
    },
    defaultHoraires: [
      {
        jour: 1,
        libelle: 'Lundi',
        value: '8-12/14-18',
      },
      {
        jour: 2,
        libelle: 'Mardi',
        value: '8-12/14-18',
      },
      {
        jour: 3,
        libelle: 'Mercredi',
        value: '8-12/14-18',
      },
      {
        jour: 4,
        libelle: 'Jeudi',
        value: '8-12/14-18',
      },
      {
        jour: 5,
        libelle: 'Vendredi',
        value: '8-12/14-18',
      },
      {
        jour: 6,
        libelle: 'Samedi',
        value: '8-12',
      },
      {
        jour: 7,
        libelle: 'Dimanche',
        value: '8-12',
      },
    ],
    societe: null,
    isLoading: false,
    fullPage: false,
    canCancel: false,
  },

  getters: {
    isLoading: (state) => state.isLoading,
    fullPage: (state) => state.fullPage,
    canCancel: (state) => state.canCancel,
    societe: (state) => state.societe,
    config: (state) => state.config,
    defaultHoraires: (state) => state.defaultHoraires,
    defaultCurrencyConfig: (state) => state.defaultCurrencyConfig,
  },

  mutations: {
    SET_LOADER(state, { isLoading, fullPage, canCancel }) {
      state.isLoading = isLoading;
      state.fullPage = fullPage;
      state.canCancel = canCancel;
    },
    SET_CONFIG(state, data) {
      state.config = Object.assign({}, state.config, data);
    },
    SET_SOCIETE(state, payload) {
      state.societe = payload;
    },
  },

  actions: {
    setLoader({ commit }, payload) {
      commit('SET_LOADER', payload);
    },
    setConfig({ commit }, payload) {
      commit('SET_CONFIG', payload);
    },
    setSociete({ commit }, payload) {
      commit('SET_SOCIETE', payload);
    },

    loadSociete({ commit }) {
      return window.axios
        .all([window.axios.get(URL_A.APP), window.axios.get(URL_S.SOCIETE)])
        .then(
          window.axios.spread((resp1, resp2) => {
            let config = {
              appName: resp1.data.app_name,
              appDeveloper: resp1.data.app_developer,
              appVersion: resp1.data.app_version,
              langues: resp1.data.langues,
            };
            commit('SET_CONFIG', config);
            commit('SET_SOCIETE', resp2.data.societe);
          })
        )
        .catch(() => {
          commit('SET_SOCIETE', null);
        });
    },
  },
};
